(function () {

  if (window.carbonoPopupInitialized) return;
  window.carbonoPopupInitialized = true;

  let blockInserted = false;
  let observer = null;
  let lastUrl = location.href;

  function isLastCollectionPage() {
    return !document.querySelector('a[rel="next"]');
  }

  function getWrapper() {
    return document.getElementById("collection-end-popup-wrapper");
  }

  function getProductContainer() {
    return document.querySelector("div.product-list__inner");
  }

  function waitForProducts(callback) {
    const interval = setInterval(() => {
      const container = getProductContainer();
      if (!container) return;

      const products = container.querySelectorAll("product-item");
      if (products.length) {
        clearInterval(interval);
        callback(container, products);
      }
    }, 150);
  }

  function insertPopup(container, wrapper) {

    if (blockInserted) return;
    if (container.querySelector(".carbono-inline-popup")) return;

    blockInserted = true;

    const block = document.createElement("div");
    block.className = "carbono-inline-popup";
    block.innerHTML = wrapper.innerHTML;
    container.appendChild(block);

    initForm(block, wrapper);
  }

  function initForm(block, wrapper) {

    const form = block.querySelector("#carbono-search-form");
    const responseBox = block.querySelector("#carbono-response");
    const formUrl = wrapper.dataset.apiForm;
    const counterUrl = wrapper.dataset.apiCounter;

    // Counter nur einmal pro Seiten-URL
    if (counterUrl) {
      fetch(counterUrl + "?referer=" + encodeURIComponent(location.href), {
        method: "POST",
        mode: "cors"
      }).catch(() => {});
    }

    if (!form) return;

    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      if (!formUrl) return;

      const consentCheckbox = form.querySelector('input[name="consent"]');
      if (consentCheckbox && !consentCheckbox.checked) {
        responseBox.innerHTML = "Bitte stimme der Datenverarbeitung zu.";
        return;
      }

      responseBox.innerHTML = "Wird verarbeitet...";

      try {

        const formData = new FormData(form);
        const data = {};

        formData.forEach((value, key) => {
          if (key !== "consent") data[key] = value;
        });

        data.consent = true;
        data.page_url = location.href;

        const response = await fetch(formUrl, {
          method: "POST",
          mode: "cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error();

        responseBox.innerHTML =
          "Danke! Wir melden uns mit passenden Vorschlägen.";

        form.reset();

      } catch (error) {
        responseBox.innerHTML =
          "Fehler beim Senden. Bitte später erneut versuchen.";
      }
    });
  }

  function observeLastProduct(container, products, wrapper) {

    if (observer) observer.disconnect();

    const lastProduct = products[products.length - 1];

    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !blockInserted) {
          insertPopup(container, wrapper);
        }
      });
    }, { threshold: 0.6 });

    observer.observe(lastProduct);
  }

  function init() {

    const wrapper = getWrapper();
    if (!wrapper) return;
    if (wrapper.dataset.popupEnabled !== "true") return;

    if (!isLastCollectionPage()) return;

    waitForProducts((container, products) => {
      observeLastProduct(container, products, wrapper);
    });
  }

  /* ===== URL CHANGE DETECTION (für AJAX Pagination) ===== */

  function watchUrlChange() {
    setInterval(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;

        blockInserted = false;
        if (observer) observer.disconnect();

        setTimeout(init, 300);
      }
    }, 500);
  }

  /* ===== EVENTS ===== */

  document.addEventListener("DOMContentLoaded", function () {
    init();
    watchUrlChange();
  });

  window.addEventListener("pageshow", function () {
    blockInserted = false;
    init();
  });

})();